module.exports = __webpack_public_path__ + "static/media/prick_HMPG_header_image_03_1000.a84822bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/prick_HMPG_header_image_03_1000.jpg
// module id = 349
// module chunks = 0